import { ICopyACHPushDetails } from './interfaces/ICopyACHPushDetails';
import { IFormValues } from './interfaces/IFormValues';

export const convertACHPushToFormValues = ({
  ach_account,
  amount_cents,
  escrow_file,
  state_abbreviation,
  id,
}: ICopyACHPushDetails): IFormValues => ({
  account_number: ach_account.account_number_last_four,
  ach_account_id: ach_account.id,
  amount: amount_cents / 100,
  beneficiary_name: ach_account.name,
  category: undefined,
  escrow_file_id: escrow_file.id,
  memo: '',
  // MF-310 Routing number should not be pre-populated
  routing_number: '',
  state_abbreviation: state_abbreviation,
  achAccountId: ach_account?.id,
  ach_push_id: id,
});
